---
title: Towards Predictable Assembly of Certifiable Assets
slug: predictable-assembly-certifiable-assets
type: paper
status: published
featured: true
summary: Enterprise application assembly where the focus is components and service-assemblies, and predictability when crossing organizational boundaries.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2008-01-01"
lastReviewedAt: "2026-09-18"
audiences:
  - product-developer
themes:
  - platform-architecture
  - product-lines
sourceUrl: https://www.academia.edu/1979275/Towards_Predictable_Assembly_of_Certifiable_Assets
originalAuthor: Jay van Zyl
sourceRelationship: academic record; PDF hosted on Academia.edu
rightsStatus: outbound-only
seoDescription: 2008 paper by Jay van Zyl on predictable assembly of certifiable software assets.
canonicalPath: /research/predictable-assembly-certifiable-assets
authors:
  - Jay van Zyl
year: 2008
venue: Component / service-oriented assembly literature
publicationType: article
citation: "van Zyl, J. (2008). Towards Predictable Assembly of Certifiable Assets."
researchTheme: application-assembly
recordUrl: https://www.academia.edu/1979275/Towards_Predictable_Assembly_of_Certifiable_Assets
---

The paper describes a common architecture for enterprise application assembly and considers predictability from a service-oriented perspective — including the trust problem Prediction-Enabled Component Technology was already naming. That concern maps onto later runtime work: a score is only useful if the assembly that serves it can be operated.
